import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    navigationBox: {
        flexGrow: 1,
        minHeight: 0,
        overflowY: "auto",
        overflowX: "hidden",
        backgroundColor:
            theme.palette.mode === "light" ? theme.palette.emteria.background.default : theme.palette.emteria.background.paper,
    },
    navigationBoxNoScroll: {
        overflowY: "hidden",
    },
    navigationContent: {},
    workspaceTitle: { position: "absolute", bottom: theme.spacing(1), left: theme.spacing(3), fontSize: 10, fontStyle: "italic" },
}));
